import { IDepositParams } from "./Deposit.t";

export const DEPOSIT_STEP_NAMES = {
    AMOUNT: 'amount',
    PAYMENT_DETAILS: 'payment_details',
    PAYMENT_FORM: 'payment_form',
    RESPAWN: 'respawn',
} as const;

export const DEPOSIT_COMPONENT_TYPES = {
    ONBOARDING: 'onboarding',
    REPEAT: 'repeat',
} as const;

export const DEPOSIT_FIELDS_ERRORS = {
    amount: ['error.minimum_deposit', 'error.next_deposit'],
} as const;

export const DEPOSIT_STEPS = {
    FILL_FORM: 'fill_form',
    PAYMENT_DETAILS: 'payment_details',
} as const;

export const DEPOSIT_PARAMS_INITIAL_STATE: IDepositParams = {
    default: 0,
    max: 0,
    min: 0,
    presets: [] as number[],
} as const;
